import PointsHistoryList from './PointsHistoryList'

export default PointsHistoryList
